import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import BoardCategoryInformation from "./BoardCategoryInformation";
import BoardHeader from "./BoardHeader";
import EmptyComponent from "./EmptyPage";
import BoardReportResult from "./BoardReportResult";
import {
  BoardDetailProvider,
  useBoard,
} from "../../../providers/BoardDetailProvider";
import BoardFooter from "./BoardFooter";
import BoardBodySlider from "./BoardBodySlider";
import BoardBodyContent from "./BoardBodyContent";
import BoardSnackbarMessage from "./BoardSnackbarMessage";
import Comments from "../comments";
import { useQueryBoardDetail, useUpdateBoardView } from "./hooks";
import { WebSocketProvider } from "../../../providers/WebsocketProvider";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import PendingApprovalCommentPage from "./BoardPendingApprovalCommentPage";

const BoardDetailContent = () => {
  const {
    state: {
      boardDetailData,
      showReportResultPage,
      showPendingApprovalCommentPage,
    },
  } = useBoard();
  const { isLoading } = useQueryBoardDetail();
  useUpdateBoardView();

  if (isLoading) {
    return <></>;
  }

  if (showPendingApprovalCommentPage) {
    return <PendingApprovalCommentPage />;
  }

  if (showReportResultPage) {
    return <BoardReportResult />;
  }

  if (!Object.keys(boardDetailData ?? {}).length) {
    return <EmptyComponent />;
  }
  return (
    <div className={STBoardDetail.container}>
      <BoardCategoryInformation />
      <div className={`${STBoardDetail.board} ${STBoardDetail.wrapper}`}>
        <BoardHeader />
        <div className={`${STBoardDetail.boardBody}`}>
          <BoardBodySlider />
          <BoardBodyContent />
        </div>
        <BoardFooter />
      </div>
      <Comments />

      <BoardSnackbarMessage />
    </div>
  );
};

const BoardDetail = () => {
  const params = useParams<{ board_id?: string }>();
  const { board_id = 0 } = params ?? {};
  const url = useMemo(() => {
    return `${process.env.REACT_APP_WEBSOCKET_ENDPOINT}/ws/${board_id}`;
  }, [board_id]);
  return (
    <WebSocketProvider url={url}>
      <BoardDetailProvider>
        <BoardDetailContent />
      </BoardDetailProvider>
    </WebSocketProvider>
  );
};

export default BoardDetail;
